<script setup>
// Transcrição ao vivo e cards de insight da chamada ativa desta conversa.
import { computed, ref, watch, nextTick } from 'vue';
import { useWhatsappCallsStore } from 'dashboard/stores/whatsappCalls';

const store = useWhatsappCallsStore();
const transcriptEl = ref(null);

const transcript = computed(() => store.transcript);
const insights = computed(() => store.insights);
const status = computed(() => store.copilotStatus);

const statusKey = computed(() => {
  if (status.value === 'unavailable') return 'UNAVAILABLE';
  if (status.value === 'ready') return 'LISTENING';
  return 'CONNECTING';
});

const TYPE_CLASS = {
  objecao: 'border-n-ruby-9 bg-n-ruby-2',
  pergunta: 'border-n-blue-9 bg-n-blue-2',
  alerta: 'border-n-amber-9 bg-n-amber-2',
  sugestao: 'border-n-teal-9 bg-n-teal-2',
};

watch(
  () => transcript.value.length,
  async () => {
    await nextTick();
    if (transcriptEl.value)
      transcriptEl.value.scrollTop = transcriptEl.value.scrollHeight;
  }
);
</script>

<template>
  <div class="flex flex-col h-full min-h-0 w-full">
    <div
      class="flex items-center justify-between px-4 py-3 border-b border-n-weak"
    >
      <span class="text-sm font-medium text-n-slate-12">
        {{ $t('CONVERSATION.WHATSAPP_CALL.COPILOT.TITLE') }}
      </span>
      <span
        class="text-xs"
        :class="status === 'unavailable' ? 'text-n-ruby-11' : 'text-n-slate-11'"
      >
        {{ $t(`CONVERSATION.WHATSAPP_CALL.COPILOT.${statusKey}`) }}
      </span>
    </div>

    <div
      class="flex flex-col gap-2 px-4 py-3 max-h-[45%] overflow-y-auto border-b border-n-weak"
    >
      <div
        v-for="(card, index) in insights"
        :key="`${card.at}-${index}`"
        class="rounded-lg border-l-4 px-3 py-2"
        :class="TYPE_CLASS[card.type] || TYPE_CLASS.sugestao"
      >
        <p class="text-[11px] uppercase tracking-wide text-n-slate-11 mb-0.5">
          {{
            $t(
              `CONVERSATION.WHATSAPP_CALL.COPILOT.TYPES.${TYPE_CLASS[card.type] ? card.type : 'sugestao'}`
            )
          }}
          ·
          {{ card.title }}
        </p>
        <p class="text-sm text-n-slate-12 mb-0">{{ card.text }}</p>
      </div>
    </div>

    <div
      ref="transcriptEl"
      class="flex-1 min-h-0 overflow-y-auto px-4 py-3 flex flex-col gap-1.5"
    >
      <p v-if="!transcript.length" class="text-xs text-n-slate-11">
        {{ $t('CONVERSATION.WHATSAPP_CALL.COPILOT.EMPTY') }}
      </p>
      <p
        v-for="(item, index) in transcript"
        :key="index"
        class="text-sm mb-0"
        :class="
          item.speaker === 'cliente' ? 'text-n-slate-12' : 'text-n-teal-11'
        "
      >
        <span class="font-medium">
          {{
            item.speaker === 'cliente'
              ? $t('CONVERSATION.WHATSAPP_CALL.COPILOT.CUSTOMER')
              : $t('CONVERSATION.WHATSAPP_CALL.COPILOT.YOU')
          }}:
        </span>
        {{ item.text }}
      </p>
    </div>
  </div>
</template>
